import s from './PageError.module.scss'
import ErrorSVG from '../../../assets/error.svg'

interface PageErrorProps {
  userMessage: string
  reloadApp: () => void
  canReload?: boolean
}

export const PageError = ({ userMessage, reloadApp, canReload = true }: PageErrorProps) => {
  return (
    <div className={s.PageError}>
      <div className={s.error_window}>
        <div className={s.error_icon}>
          <img src={ErrorSVG} alt="Camera Error" />
        </div>
        {userMessage && <p className={s.error_text}>{userMessage}</p>}
        {canReload && (
          <button className={s.reload_button} onClick={reloadApp}>
            Reload
          </button>
        )}
      </div>
    </div>
  )
}
